import { render } from "./OnlineOrderBoard.vue?vue&type=template&id=455e8167"
import script from "./OnlineOrderBoard.vue?vue&type=script&lang=js"
export * from "./OnlineOrderBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__